var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageInfo48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconInfo48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Icons/pictograms/picto-ui-info-32-Copy-2",
    fill: "#0063FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C37.254834,0 48,10.745166 48,24 C47.9848847,37.248568 37.248568,47.9848847 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M24,3.42857143 C12.6387137,3.42857143 3.42857143,12.6387137 3.42857143,24 C3.42857143,35.3612863 12.6387137,44.5714286 24,44.5714286 C35.3612863,44.5714286 44.5714286,35.3612863 44.5714286,24 C44.559146,12.6438052 35.3561948,3.44085402 24,3.42857143 Z M24.0411429,17.664 C25.6457143,17.664 26.9622857,18.9805714 26.9622857,20.5028571 L26.9622857,20.5028571 L26.9622857,36.7954286 C26.9622857,38.3588571 25.6457143,39.6342857 24.0411429,39.6342857 C22.3954286,39.6342857 21.12,38.3588571 21.12,36.7954286 L21.12,36.7954286 L21.12,20.5028571 C21.12,18.9805714 22.3954286,17.664 24.0411429,17.664 Z M24.0411429,9.14742857 C25.9748571,9.14742857 27.4971429,10.6285714 27.4971429,12.5211429 C27.4971429,14.4137143 25.9748571,15.9771429 24.0411429,15.9771429 C22.0662857,15.9771429 20.5028571,14.4137143 20.5028571,12.5211429 C20.5028571,10.6285714 22.0662857,9.14742857 24.0411429,9.14742857 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInfo48);
export default __webpack_public_path__ + "static/media/messageInfo48.15d79f2eb4159018beefb1cb3f6ade7b.svg";
export { ForwardRef as ReactComponent };